export enum AppointmentChannel {
  CREATE = 'appointment::create',
  EDIT = 'appointment::patch',
  DELETE = 'appointment::delete',
}
